import { isPresent } from 'utils/isPresent';
import React, { PureComponent } from 'react'
import ExpansionPanel from 'housecall-ui/dist/DesignSystem/Surfaces/ExpansionPanels/ExpansionPanel'
import ExpansionPanelDetails from 'housecall-ui/dist/DesignSystem/Surfaces/ExpansionPanels/ExpansionPanelDetails'
import ExpansionPanelSummary from 'housecall-ui/dist/DesignSystem/Surfaces/ExpansionPanels/ExpansionPanelSummary'
import Divider from 'housecall-ui/dist/DesignSystem/DataDisplay/Divider/Divider'
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid'
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography'
import ui from 'redux-ui'
import { connect } from 'react-redux'
import { isValidDate } from '../../Invoice/Data.js'
import CreateUpdateTaskHeader from './CreateUpdateTaskHeader.jsx'
import CreateUpdateDateSelection from './CreateUpdateDateSelection.jsx'
import CreateUpdateDescription from './CreateUpdateDescription.jsx'
import CreateUpdateTitle from './CreateUpdateTitle.jsx'
import CreateUpdateServiceProSelection from './CreateUpdateServiceProSelection.jsx'
import { fetchEmployeesList, getEmployeesList } from './EmployeesData'
import { deleteTask, updateTask } from './Redux/Actions'
import { FetchData } from '../../Common/Data/DataFetcher'
import TaskEvents from './TaskEvents.jsx'
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles'
import ExpandMoreIcon from 'housecall-ui/dist/IconsAndImages/Icons/ExpandMore'
import CustomerSelection from './Customers/CustomerSelection.jsx'
import moment from 'moment-timezone'
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider'

const styles = () => ({
  root: {
    width: '98%',
  },
  listTextRoot: {
    '&:first-child': {
      paddingLeft: 0,
    },
  },
  expansionPanelDetails: {
    padding: 2,
    display: 'inherit',
  },
})

@connect(
  state => ({
    servicePros: getEmployeesList(state),
  }),
  dispatch => ({
    updateTask: task => {
      dispatch(updateTask(task))
    },
    deleteTask: id => {
      dispatch(deleteTask(id))
    },
  })
)
@ui({
  state: {
    id: props => props.task.id,
    title: props => props.task.title || '',
    description: props => props.task.description || '',
    due: props =>
      isPresent(props.task.due)
        ? moment(props.task.due).format('YYYY-MM-DD')
        : null,
    servicePro: props => props.task.service_pro || {},
    customer: props => props.task.customer || {},
    contentUpdated: false,
    openTaskEvents: false,
    errorMessage: 'Invalid date',
    validDate: true,
  },
})
@withStyles(styles)
@FetchData(fetchEmployeesList, false)
export default class CreateUpdateTask extends PureComponent {
  constructor(props) {
    super(props)

    this.handleDueDateChange = this.handleDueDateChange.bind(this)
    this.handleEmployeeChange = this.handleEmployeeChange.bind(this)
  }

  buildTaskEvents() {
    const { ui, classes } = this.props
    if (ui.id) {
      return (
        <div className={classes.root}>
          <ExpansionPanel elevation={0}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1">Activity</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={classes.expansionPanelDetails}>
              <Divider />
              <TaskEvents taskId={ui.id} />
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </div>
      )
    }
  }

  handleDueDateChange(due) {
    if (isValidDate(due)) {
      this.props.updateUI('validDate', true)
      this.props.updateUI('due', due)
      this.props.updateUI('contentUpdated', true)
      this.autoUpdateTask({ due: due })
    } else {
      this.props.updateUI('validDate', false)
    }
  }

  handleEmployeeChange(servicePro) {
    this.props.updateUI('servicePro', servicePro)
    this.props.updateUI('contentUpdated', true)
    this.autoUpdateTask({ service_pro: servicePro })
  }

  buildContent() {
    const { ui, servicePros } = this.props
    return (
      <HousecallThemeProvider>
        <Grid
          container
          item
          direction="column"
          alignItems="center"
          justify="center"
          spacing={16}
        >
          <CreateUpdateTitle
            title={ui.title}
            onTitleChange={title => {
              this.props.updateUI('title', title)
              this.props.updateUI('contentUpdated', true)
              this.autoUpdateTask({ title: title })
            }}
          />

          <CreateUpdateDescription
            description={ui.description}
            onDescriptionChange={description => {
              this.props.updateUI('description', description)
              this.props.updateUI('contentUpdated', true)
              this.autoUpdateTask({ description: description })
            }}
          />

          <CreateUpdateDateSelection
            due={this.props.ui.due}
            error={!ui.validDate}
            label={ui.validDate ? 'Add date' : ui.errorMessage}
            onDueDateChange={this.handleDueDateChange}
          />

          <CreateUpdateServiceProSelection
            servicePros={servicePros}
            selectedServicePro={ui.servicePro}
            onEmployeeChange={this.handleEmployeeChange}
          />

          <CustomerSelection
            customer={ui.customer}
            onCustomerChange={customer => {
              this.props.updateUI('customer', customer)
              this.props.updateUI('contentUpdated', true)
              this.autoUpdateTask({ customer: customer })
            }}
          />

          {this.buildTaskEvents()}
        </Grid>
      </HousecallThemeProvider>
    )
  }

  autoUpdateTask(attributes) {
    let task = Object.assign(this.props.task, attributes)
    this.props.updateTask(task)
  }

  render() {
    const { ui } = this.props
    return (
      <Grid container direction="column" spacing={16} wrap="nowrap">
        <Grid item>
          <CreateUpdateTaskHeader
            showDelete={ui.id !== -1}
            onDeleteTask={() => {
              this.props.deleteTask(ui.id)
            }}
          />
        </Grid>
        {this.buildContent()}
      </Grid>
    )
  }
}
